import styled from "styled-components"

export const BasicTextGalleryModuleStyles = styled.section`
    margin-top: var(--sectionMargin);
    margin-bottom: var(--sectionMargin);
    background: var(--primary);
    &.nomargin {
        margin-top: 0;
        margin-bottom: 0;
    }    

  a {
    color:#000;
  }
  
  .container-wrapper {
    display:flex;
    flex-direction: column;
    background: var(--primary);
    
    .gallery{
        display:grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        img {
            max-width: 100%;
            margin: auto;
        }
    }

    .gallery.single {
      grid-template-columns: 1fr;
    }

    @media (min-width: 768px) {
    flex-direction: row;
      > div {
          color:var(--bodyColor);
         width: 50%;
        max-width: 1000px; 
      }
    }

    @media (min-width: 768px) {
        flex-direction: row;
          > div.lg {
              color:var(--bodyColor);
             width: 60%;
            max-width: 1000px; 
          }
          > div.sm {
            color:var(--bodyColor);
           width: 40%;
            max-width: 1000px; 
          }
        }
  }


`
